import AutoComplete from '@tarekraafat/autocomplete.js/dist/autoComplete';

export const autocomplete = {
	initContactAutocomplete: () => {
		const autoCompleteElmts = document.querySelectorAll( 'input.contact-autocomplete' );
		autoCompleteElmts.forEach( ( elmt ) => {
			const data = window.contactAutocompleteData;
			const autocompleteSrc = [];
			for ( const [ contactId, contactData ] of Object.entries( data ) ) {
				contactData.data.autocompleteString = contactData.data.FirstName + ' ' + contactData.data.LastName;
				autocompleteSrc.push( contactData.data );
			}
			const config = {
				selector: () => {
					return elmt;
				},
				data: {
					src: autocompleteSrc,
					keys: [ 'autocompleteString' ],
					cache: true,
				},
				diacritics: true,
				resultItem: {
					highlight: true,
				},
				events: {
					input: {
						selection: ( event ) => {
							const selectedContact = event.detail.selection.value;
							event.target.value = selectedContact.LastName;
							const form = event.target.closest( 'form ' );
							const resultFields = form.querySelectorAll( '[data-autocomplete-result-field]' );
							resultFields.forEach( ( resultField ) => {
								const fieldName = resultField.dataset.autocompleteResultField;
								if ( selectedContact.hasOwnProperty( fieldName ) ) {
									resultField.value = selectedContact[ fieldName ];
								}
							} );
						},
						focus: ( event ) => {
							if ( event.target.value.length ) {
								autocompleteJS.start();
							}
						},
					},
				},
			};
			const autocompleteJS = new AutoComplete( config );
		} );
	},
};
